// src/views/Parametros/Estados/VerEstado.jsx
import React, { useEffect, useState } from "react";

export default function VerEstado({ id, onClose = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [estado, setEstado] = useState(null);

  // MOCK de datos (simula API)
  const MOCK_ESTADOS = [
    { id: 1, descripcion: "CLIENTE ACTIVO", tipo: "CLIENTES" },
    { id: 2, descripcion: "CLIENTE BLOQUEADO POR DEUDA", tipo: "CLIENTES" },
    { id: 3, descripcion: "CLIENTE INACTIVO", tipo: "CLIENTES" },
    { id: 4, descripcion: "CONTRATO ACTIVO", tipo: "CONTRATO" },
    { id: 5, descripcion: "CONTRATO INACTIVO", tipo: "CONTRATO" },
    {
      id: 6,
      descripcion: "FACTURA ENVIADA A SAP",
      tipo: "FACTURA DE CLIENTES",
    },
    { id: 7, descripcion: "FACTURA IMPRESA", tipo: "FACTURA DE CLIENTES" },
  ];

  // Simula carga desde API
  useEffect(() => {
    setLoading(true);
    setErr("");

    const timer = setTimeout(() => {
      const found = MOCK_ESTADOS.find((e) => e.id === id);

      if (!found) {
        setErr("No se encontró el estado solicitado.");
      } else {
        setEstado(found);
      }

      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [id]);

  const rows = [
    ["Descripción", estado?.descripcion ?? ""],
    ["Estado Tipo", estado?.tipo ?? ""],
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* Encabezado */}
        <div className="modal-header">
          <h2 className="section-title">Datos del Estado</h2>
        </div>

        {/* Contenido */}
        <div className="modal-body">
          {loading && (
            <div className="py-6 text-center text-gray-600">Cargando…</div>
          )}

          {!loading && err && (
            <div className="py-6 text-center text-red-600">{err}</div>
          )}

          {!loading && !err && estado && (
            <div className="form-grid mb-4">
              {rows.map(([label, value]) => (
                <Fila key={label} label={label} value={value} />
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">{value || ""}</div>
    </div>
  );
}
